import actionTypes from '../../../redux/actionTypes'

export const setSelectableUserTypes = (types) => ({
  type: actionTypes.SET_SELECTABLE_USER_TYPES,
  payload: types
})
